import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";
import "./RightSidebar456.css";

const COLORS = [
  "#4c1d95", "#9333ea", "#a855f7", "#c084fc", "#ddd6fe",
  "#f9a8d4", "#f472b6", "#ec4899", "#be185d", "#f43f5e"
];

// Aggregate top 10 purposes and group the rest as "Others"
function aggregatePurposes(purposes) {
  const entries = Object.entries(purposes || {});
  entries.sort((a, b) => b[1] - a[1]);
  const top = entries.slice(0, 10);
  const rest = entries.slice(10);
  const otherTotal = rest.reduce((sum, [, val]) => sum + val, 0);
  if (otherTotal > 0) top.push(["Others", otherTotal]);
  return top.map(([name, value]) => ({ name, value }));
}

export default function RightSidebar({
  metrics,
  metric,
  hoveredPurposeData,     // Borrowing
  hoveredDbtPhoneData     // DBT
}) {
  const chartData = Object.entries(metrics).map(([state, vals]) => ({
    state,
    value: vals[metric] ? vals[metric] * 100 : 0,
  }));

  const topStates = chartData.sort((a, b) => b.value - a.value).slice(0, 5);

  return (
    <div className="right-sidebar">
      {/* Bar chart */}
      <h3>Top 5 States by {metric.replace("_", " ")}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={topStates} layout="vertical" margin={{ left: 30 }}>
          <XAxis type="number" />
          <YAxis dataKey="state" type="category" width={100} />
          <Tooltip />
          <Bar dataKey="value" fill="url(#violetGradient)" />
          <defs>
            <linearGradient id="violetGradient" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#c084fc" />
              <stop offset="100%" stopColor="#6b21a8" />
            </linearGradient>
          </defs>
        </BarChart>
      </ResponsiveContainer>

      {/* Borrowing – Pie chart for loan purposes */}
      {hoveredPurposeData && (
        <div className="pie-chart-container">
          <h4>{hoveredPurposeData.state} - Purpose of Loan</h4>
          <div style={{ width: "100%", height: 200 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={aggregatePurposes(hoveredPurposeData?.data || {})}
                  dataKey="value"
                  nameKey="name"
                  outerRadius={90}
                  labelLine={false}
                  label={false}
                >
                  {aggregatePurposes(hoveredPurposeData?.data || {}).map(
                    (entry, idx) => (
                      <Cell
                        key={`cell-${idx}`}
                        fill={COLORS[idx % COLORS.length]}
                      />
                    )
                  )}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="custom-legend">
            {aggregatePurposes(hoveredPurposeData?.data || {}).map(
              (entry, idx) => (
                <div key={idx} className="legend-item">
                  <span
                    className="legend-color"
                    style={{ backgroundColor: COLORS[idx % COLORS.length] }}
                  />
                  <span className="legend-text">
                    {entry.name} ({(entry.value * 100).toFixed(1)}%)
                  </span>
                </div>
              )
            )}
          </div>
        </div>
      )}

      {/* DBT – Pie chart for phone types */}
      {hoveredDbtPhoneData && (
        <div className="pie-chart-container">
          <h4>{hoveredDbtPhoneData.state} - Phone Type Distribution</h4>
          <div style={{ width: "100%", height: 200 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={Object.entries(hoveredDbtPhoneData?.data || {}).map(
                    ([name, value]) => ({
                      name,
                      value: value * 100, // convert to %
                    })
                  )}
                  dataKey="value"
                  nameKey="name"
                  outerRadius={90}
                  labelLine={false}
                  label={false}
                >
                  {Object.entries(hoveredDbtPhoneData?.data || {}).map(
                    ([name, value], idx) => (
                      <Cell
                        key={`cell-phone-${idx}`}
                        fill={COLORS[idx % COLORS.length]}
                      />
                    )
                  )}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="custom-legend">
            {Object.entries(hoveredDbtPhoneData?.data || {}).map(
              ([name, value], idx) => (
                <div key={idx} className="legend-item">
                  <span
                    className="legend-color"
                    style={{ backgroundColor: COLORS[idx % COLORS.length] }}
                  />
                  <span className="legend-text">
                    {name} ({(value * 100).toFixed(1)}%)
                  </span>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}
